import { type ComponentProps, type ComponentType } from 'react';
import { Controller } from 'react-hook-form';
import { type ControllerRenderProps } from 'react-hook-form/dist/types/controller';

import { Control, type ControlOuterProps } from '@/components/common/Control';
import { Select, type SelectableValue, type SelectProps } from '@/components/common/select/Select';

type FormSelectProps<
  Value extends SelectableValue,
  Component extends ComponentType<any> | undefined,
> = ControlOuterProps &
  Omit<
    Component extends ComponentType<any>
      ? { component: Component } & ComponentProps<Component>
      : { component?: never } & SelectProps<Value>,
    'state' | keyof ControllerRenderProps
  > & {
    name: string;
  };

export const FormSelect = <Value extends SelectableValue, Component extends ComponentType<any> | undefined>(
  props: FormSelectProps<Value, Component>
) => {
  const { name, component, label, ...selectProps } = props;

  const Component = (component ?? Select) as ComponentType<any>;

  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => (
        <Control label={label} error={fieldState.error?.message}>
          <Component state={fieldState.invalid ? 'error' : 'default'} {...selectProps} {...field} />
        </Control>
      )}
    />
  );
};
